/* Sticky product gallery — carousel layout, >= 768px.
 *
 * CSS `position: sticky` does not work here: the gallery's ancestor
 * `.product-info-inner` has `overflow: hidden`, which disables sticky (it can
 * only stick within that clipped box). Instead we translate the gallery column
 * with the scroll so it stays pinned just below the header while the longer
 * product-information column scrolls past it, clamped to the grid-row bounds.
 *
 * Smoothness: geometry (heights, row offset) is measured ONCE — on load,
 * resize, and when the row changes size (ResizeObserver) — and cached. The
 * per-scroll-frame work then only reads the scroll position and writes a
 * transform, with NO forced layout, so it tracks the scroll without jitter.
 */
(function () {
  'use strict';

  var MIN_WIDTH = 768;
  var GAP = 16; // breathing room below the header

  function setup(layout) {
    var gallery = layout.querySelector('.product__gallery-col');
    if (!gallery) return;
    var row = gallery.parentElement; // the md:grid row (gallery + information)
    if (!row) return;

    var rowTopDoc = 0; // row top in document coordinates (cached)
    var maxTravel = 0; // how far the gallery may move before the row bottom
    var active = false;
    var ticking = false;

    function headerOffset() {
      var v = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-group-height-dynamic')
      );
      return (isNaN(v) ? 0 : v) + GAP;
    }

    /* Cache the geometry. This is the ONLY place that reads layout, so it never
       runs during a scroll. */
    function measure() {
      active = window.innerWidth >= MIN_WIDTH;
      if (!active) {
        gallery.style.transform = '';
        gallery.style.alignSelf = '';
        gallery.style.willChange = '';
        return;
      }
      gallery.style.alignSelf = 'start';   // stop the grid stretching the column
      gallery.style.willChange = 'transform';
      rowTopDoc = row.getBoundingClientRect().top + window.pageYOffset;
      maxTravel = row.offsetHeight - gallery.offsetHeight;
      position();
    }

    /* Per-frame: cheap reads only (scroll position + a CSS var), no layout. */
    function position() {
      if (!active || maxTravel <= 0) {
        gallery.style.transform = '';
        return;
      }
      // Round to whole pixels — a fractional translate on a composited layer
      // resamples the texture at subpixel offsets, which shimmers (and reads as
      // a tiny horizontal wobble). Snapping to integers keeps it crisp.
      var y = Math.max(0, Math.min(window.pageYOffset + headerOffset() - rowTopDoc, maxTravel));
      gallery.style.transform = 'translate3d(0,' + Math.round(y) + 'px,0)';
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          position();
        });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) {
      new ResizeObserver(measure).observe(row);
    }
    measure();
  }

  function boot() {
    var layouts = document.querySelectorAll('.product__layout--carousel');
    for (var i = 0; i < layouts.length; i++) setup(layouts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
